/**
 * Safe wrappers around localStorage for non-sensitive UI preferences (theme, last workspace).
 * Storage can be unavailable (private mode, blocked site data), so every access is guarded.
 * Never store tokens or personal data here (ADR-010).
 */
const PREFIX = 'lm.';

export function readPreference(key: string): string | null {
  try {
    return localStorage.getItem(PREFIX + key);
  } catch {
    return null;
  }
}

export function writePreference(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(PREFIX + key);
    else localStorage.setItem(PREFIX + key, value);
  } catch {
    // Preferences are a convenience; ignore storage failures.
  }
}
